// src/features/dashboard/admin/StatsSection.jsx
import React from 'react';
import { StatCard } from './StatCard';

export const StatsSection = ({ stats }) => (
  <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
    <StatCard title="Students" value={stats.students} color="bg-blue-600" icon="👨‍🎓" />
    <StatCard title="Teachers" value={stats.teachers} color="bg-indigo-600" icon="👨‍🏫" />
    <StatCard title="Admins" value={stats.admins} color="bg-purple-600" icon="👤" />
    <StatCard title="Classes" value={stats.classes} color="bg-green-600" icon="📚" />
  </div>
);